import { Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CheckpointGroupFilterDto, CheckpointGroupItemDto, CheckpointGroupService, } from '@artemis-software/wr-api';
import { FormBuilder, FormGroup } from '@angular/forms';
import { catalogReadOnlyBanner, catalogTenantId, isCatalogReadOnly, isInternalTenant } from '@/utils/admin-utils';

@Component({
  standalone: false,
  selector: 'wr-checkpoint-group-overview-page',
  templateUrl: './checkpoint-group-overview-page.component.html',
  styleUrls: ['./checkpoint-group-overview-page.component.scss'],
})
export class CheckpointGroupOverviewPageComponent{

  private readonly checkpointGroupService = inject(CheckpointGroupService);
  private readonly router = inject(Router);
  readonly form: FormGroup;

  private readonly internalTenant = isInternalTenant();
  readonly catalogReadOnly = isCatalogReadOnly();
  readonly catalogBanner = catalogReadOnlyBanner();
  readonly isAdmin = computed(() => this.internalTenant() && !this.catalogReadOnly());
  readonly tenantId = catalogTenantId();

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      text: [''],
      deprecated: [false],
    });
  }

  readonly loadCheckpointGroups = (filter: CheckpointGroupFilterDto) => {
    return this.checkpointGroupService.findAll({
      ...this.form.value,
      ...filter,
      tenantId: this.tenantId()
    });
  };

  readonly getCount = (filter: CheckpointGroupFilterDto) => {
    return this.checkpointGroupService.getCount({
      ...this.form.value,
      ...filter,
      tenantId: this.tenantId()
    });
  };

  navigateToCheckpointGroup(checkpointGroup: CheckpointGroupItemDto): void {
    this.router.navigate(['checkpointGroup', checkpointGroup.id]);
  }

  add(): void {
    this.router.navigate(['checkpointGroup', 'new']);
  }

  cleanName(name: string): string {
    return name.replace(/_/g, ' ');
  }
}
